<div class="flex flex-col gap-4">
  <h5 class="text-xl">{{ myTranslation("officeAddin.billingData") }}</h5>
  <p-floatLabel variant="in">
    <p-calendar
      [(ngModel)]="myDate"
      selectionMode="range"
      dateFormat="dd.mm.yy"
      (click)="resetDateSelector()"
    ></p-calendar>
    <label [class]="dateSelectorState">{{ myTranslation("officeAddin.timeFrame") }}</label>
  </p-floatLabel>
  <span>
    <p-inputSwitch
      id="allOrganizations"
      [(ngModel)]="allOrganizations"
      (onChange)="resetOrganizationSelector()"
    ></p-inputSwitch>
    <label for="allOrganizations" class="ml-2">{{ myTranslation("officeAddin.allOrganizations") }}</label>
  </span>
  <p-floatLabel variant="in">
    <p-dropdown
      [filter]="true"
      [disabled]="allOrganizations"
      [options]="licensedOrganizations"
      [group]="true"
      [(ngModel)]="selectedOrganization"
      [style]="{ width: '100%' }"
      [panelStyle]="{ width: '100%' }"
      (click)="resetOrganizationSelector()"
    >
    </p-dropdown>
    <label [class]="organizationSelectorState">{{ myTranslation("officeAddin.organizations") }}</label>
  </p-floatLabel>

  <span>
    <p-inputSwitch [(ngModel)]="includeVirtualBookings"></p-inputSwitch>
    <label for="allOrganizations" class="ml-2">{{ myTranslation("officeAddin.includeVirtualBookings") }}</label>
  </span>

  <p-floatLabel variant="in">
    <p-multiSelect
      [options]="tableTypes"
      [(ngModel)]="selectedTableType"
      [style]="{ width: '100%' }"
      [panelStyle]="{ width: '100%' }"
      (click)="resetTableSelector()"
    >
    </p-multiSelect>
    <label [class]="tableSelectorState">{{ myTranslation("officeAddin.analysis") }}</label>
  </p-floatLabel>
  <new-ui-button [label]="myTranslation('officeAddin.billingDataImport')" (click)="getData()"></new-ui-button>
</div>
